import ModelUtil from '@leverege/model-util'
import I18N from '@leverege/i18n'

import DailyHours from './DailyHours.js'

const { t } = I18N.ns( 'imagine.operatingHours.WeeklyHours' )

const TYPE = 'imagine.operatingHours.weekly'

function create( options ) {
  const opts = options || {}

  return {
    type : TYPE,
    name : opts.name || 'Default',
    monday : opts.monday || DailyHours.create( { name : t( 'monday' ) } ),
    tuesday : opts.tuesday || DailyHours.create( { name : t( 'tuesday' ) } ),
    wednesday : opts.wednesday || DailyHours.create( { name : t( 'wednesday' ) } ),
    thursday : opts.thursday || DailyHours.create( { name : t( 'thursday' ) } ),
    friday : opts.friday || DailyHours.create( { name : t( 'friday' ) } ),
    saturday : opts.saturday || DailyHours.create( { name : t( 'saturday' ), open : false } ),
    sunday : opts.sunday || DailyHours.create( { name : t( 'sunday' ), open : false } )
  }
}

export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue( 'name' ),
  ...ModelUtil.createAllValue( 'monday' ),
  ...ModelUtil.createAllValue( 'tuesday' ),
  ...ModelUtil.createAllValue( 'wednesday' ),
  ...ModelUtil.createAllValue( 'thursday' ),
  ...ModelUtil.createAllValue( 'friday' ),
  ...ModelUtil.createAllValue( 'saturday' ),
  ...ModelUtil.createAllValue( 'sunday' )
}
